// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2fUMF","list":"styles_list__9Ku7X"};